var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrollV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7706 21.6854L16.6786 17.8337C17.3652 17.157 16.8789 16 15.908 16H8.09203C7.12108 16 6.63483 17.157 7.32139 17.8337L11.2294 21.6854C11.655 22.1049 12.345 22.1049 12.7706 21.6854Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7706 2.31461L16.6786 6.1663C17.3652 6.84298 16.8789 8 15.908 8H8.09203C7.12108 8 6.63483 6.84298 7.32139 6.1663L11.2294 2.31461C11.655 1.89513 12.345 1.89513 12.7706 2.31461Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollV);
export default __webpack_public_path__ + "static/media/scroll-v.ca25f0994c5bb155447a982af7758cd3.svg";
export { ForwardRef as ReactComponent };